<template>
  <div class="">
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <div class="flex operaBox padding-sm margin-top-sm">
      <div
        class="operation flex align-center padding-tb-xs"
        v-for="(item,index) in overviewList"
        :key="index"
      >
        <div class="margin-left-sm margin-right-sm operateImg"><img
            class="operateIcon"
            :src="item.img"
          /></div>
        <img
          class="right-icon margin-lr-sm"
          src="@/assets/images/site/tri.png"
        >
        <div class="flex flex-direction">
          <p class="text-xsss">{{item.text}}</p>
          <div
            class="text-xxl-xl DS-font"
            :class="{'text-sm normalFont':index==0}"
            :style="{'color':item.number.style.fill}"
          >{{item.number.content}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BigTitle from "@/components/bigTitle";
// 综合态势--动态渲染图片
import overview0 from "@/assets/images/index/overview1.png";
import overview1 from "@/assets/images/index/overview4.png";
import overview2 from "@/assets/images/index/overview2.png";
import overview3 from "@/assets/images/index/overview3.png";
import overview4 from "@/assets/images/index/overview3.png";

import { siteLeft } from "@/api/singleSite/left";
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data() {
    return {
      options: {},
      bigtitle: {
        CHN: "电池信息",
        ENG: "Overview",
      },
      overviewList: [
        {
          text: "当前状态",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#36FBFB",
              fontFamily: "DS-Digital-Bold",
              fontSize:36,
            },
          },
          img: overview2,
        },
        // {
        //   text: "电池包编码",
        //   number: {
        //     content: "0",
        //     textAlign: "left",
        //     style: {
        //       fill: "#43FFB9",
        //       fontFamily: "DS-Digital-Bold",
        //       fontSize: 50,
        //     },
        //   },
        //   img: overview1,
        // },
        {
          text: "当前电量(kWh)",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#FFFFFF",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview3,
        },
        {
          text: "累计换电次数",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#179DFF",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview3,
        },
        {
          text: "累计充电次数",
          number: {
            content: "0",
            textAlign: "left",
            style: {
              fill: "#179DFF",
              fontFamily: "DS-Digital-Bold",
              fontSize: 50,
            },
          },
          img: overview3,
        }
      ],
    };
  },
  components: {
    BigTitle,
  },
  props: {
    batteryInfo: {
      type: Object,
      default: () => ({})
    },
  },
  mounted() {
  },
  methods: {
    getData(data){
      this.dianchixinxi1(data);
    },
    dianchixinxi1(data){
      let params = {
          "enCode":"TiDB-dianchixiang-dianchixinxi",
          "@battery_id":data.batteryId
      }
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          // 充电状态2-充电；3-充电完成
          let info = res[0];
            let status = info.status==2?'充电中':info.status==3?'充电完成':'';
            this.overviewList= [
              {
                text: "当前状态",
                number: {
                  content: status,
                  textAlign: "left",
                  style: {
                    fill: "#36FBFB",
                    fontFamily: "DS-Digital-Bold",
                    fontSize: 36,
                  },
                },
                img: overview2,
              },
              {
                text: "充电电量（度）",
                number: {
                  content: info.ElectAmount,
                  textAlign: "left",
                  style: {
                    fill: "#43FFB9",
                    fontFamily: "DS-Digital-Bold",
                    fontSize: 50,
                  },
                },
                img: overview1,
              },
              {
                text: "当前电量(kWh)",
                number: {
                  content: info.currentRemainingPower,
                  textAlign: "left",
                  style: {
                    fill: "#FFFFFF",
                    fontFamily: "DS-Digital-Bold",
                    fontSize: 50,
                  },
                },
                img: overview3,
              },
              {
                text: "累计换电次数",
                number: {
                  content: info.changePowerNum,
                  textAlign: "left",
                  style: {
                    fill: "#179DFF",
                    fontFamily: "DS-Digital-Bold",
                    fontSize: 50,
                  },
                },
                img: overview3,
              },
              {
                text: "累计充电次数",
                number: {
                  content: info.chargingTimesCnt,
                  textAlign: "left",
                  style: {
                    fill: "#179DFF",
                    fontFamily: "DS-Digital-Bold",
                    fontSize: 50,
                  },
                },
                img: overview3,
              }
            ]
        })
        .catch((err) => {
          console.log(err);
        });
    }
    
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/overview.scss";
.right-icon {
  width: 14px;
  height: 16px;
}
.normalFont{
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif!important;

}
</style>